import React, { useState, useEffect } from "react";
import Layout from "../../../components/layout/Layout";
import TodayFollowupComponent from "../../../components/admin/candidate/today-followups/TodayFollowupComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import masterDataService from "../../../services/master-data-service";
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import { useHistory } from "react-router";

const TodaysFollowups = () => {
    const history = useHistory();
    const [status, setStatus] = useState<IdNameModel[]>([]);
    const [refreshStatus, setRefreshStatus] = useState<number>(2);

    useEffect(() => {
        getStatus();
    }, []);

    const getStatus = () => {
        setRefreshStatus(2);
        modalUtils.showLoader();
        masterDataService.loadStatus().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setStatus(res.items);
            setRefreshStatus(refreshStatus * 5);
        }).catch((error) => {
            setRefreshStatus(refreshStatus * 5);
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Status");
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Today's Follow-ups
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header">Today's Follow-ups</h4>
            </div>
            {refreshStatus > 2 &&
                <TodayFollowupComponent statusList={status} />
            }
        </Layout>
    );
};
export default TodaysFollowups;